import Lantern from "./Lantern";
import Coin from "./Coin";
import { FireworksRight, FireworksLeft } from "./Fireworks";
import { isExpiredNewYear } from "../utils";

/**
 * @description Header 裝飾物集合
 * @returns {JSX.Element}
 */
const HeaderDecorations = () => {
  // 如果新年裝飾已過期，則不顯示任何裝飾物
  if (isExpiredNewYear()) return null;

  return (
    <>
      <Lantern />
      <Coin />
      <FireworksRight sx={{ top: "0rem", left: "-12rem" }} />
      <FireworksLeft />
    </>
  );
};
export default HeaderDecorations;
